import * as React from 'react';
import { Link as ScrollLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

export interface ScrollTopProps {
}

export interface ScrollTopState {
}

export default class ScrollTop extends React.Component<ScrollTopProps, ScrollTopState> {
  constructor(props: ScrollTopProps) {
    super(props);

    this.state = {
    }
  }

  public componentDidMount(){
    scroll.scrollToTop({

        duration: 0,
    });
  }

  public render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/scroll-top.tsx